import Warning from "../../../assets/warning.png";
import Button from "../../../custom/button/button";
import styles from "./paymentWarning.module.scss";

const PaymentWarning = ({
  onOk,
  onCancel,
}: {
  onOk: () => void;
  onCancel: () => void;
}) => {
  return (
    <div className="modalContent">
      <img src={Warning} alt="warning" />
      <h2 className={styles.modalContentHeading}>Pending Payment</h2>
      <p>
        If you have a pending payment, kindly hold on for a few hours before
        initiating a new payment.
      </p>
      <div className="buttonGroup">
        <Button className={styles.greyBtn} onClick={onCancel} text="Cancel" />
        <Button onClick={onOk} text="Proceed anyway" />
      </div>
    </div>
  );
};

export default PaymentWarning;
